import _path from "path";
import _fs from "fs";
import _convertToHtml from "../functions/quill/convertToHtml.js";
import _getFormatOptions from "../functions/helpers/getFormatOptions.js";
import _removeInvalidEvents from "../functions/eventGroups/removeInvalidEvents.js";
import _tsFunc from "../functions/profiles/tsStream.js";
import _Event from "../classes/event.js";
const Event = _Event;
const tsFunc = _tsFunc;
const removeInvalidEvents = _removeInvalidEvents;
const getFormatOptions = _getFormatOptions;
const convertToHtml = _convertToHtml;
const fs = _fs;
const path = _path;

/** Last decode options (CLI is single-threaded); used by postProcess.decode. */
let lastDecodeOptions = {};
const filterEvents = events => events.filter(event => {
  const plain = (event.text || "").replace(/<[^>]+>/g, "").trim();
  return plain.length > 0 && event.end > event.start;
});

/**
 * DVB Teletext TS stream profile.
 * Payload-only BINs use a field clock (no PTS/DTS/PCR).
 * MPEG-TS / PES+PTS inputs are demuxed then timed with pts - basePts.
 */
export default {
  decode: function (input, options) {
    const decodingOptions = getFormatOptions(options.formatOptions);
    lastDecodeOptions = decodingOptions;
    const targetPage = parseInt(decodingOptions["Teletext Page"] || "888", 10);
    const fieldRate = parseFloat(decodingOptions["Field Rate"] || "50") || 50;
    const videoFrameRate = parseFloat(options.frameRate) || 25;
    const timeline = tsFunc.extractDisplayTimeline(input, {
      fieldRate,
      page: targetPage,
      videoFrameRate
    });
    if ((decodingOptions["Dump Timeline"] || "no") === "yes") {
      let outPath = decodingOptions["Timeline Path"];
      if (!outPath && options.jobInfo && options.jobInfo.target) {
        outPath = String(options.jobInfo.target).replace(/\.[^.\\/]+$/, "") + ".timeline.json";
      }
      if (!outPath) {
        outPath = path.join("test", "exports", "output_bin.timeline.json");
      }
      fs.mkdirSync(path.dirname(path.resolve(outPath)), {
        recursive: true
      });
      fs.writeFileSync(outPath, JSON.stringify(timeline, null, 2), "utf8");
      console.log(`[tsStream] Wrote display timeline (${timeline.length} entries) → ${outPath}`);
    }
    return tsFunc.timelineToEvents(timeline, {
      fieldRate
    }).map(e => new Event(e));
  },
  encode: function () {
    throw new Error("This profile [DVB Teletext TS Stream] is not supported for encoding by Closed Caption Converter.");
  },
  preProcess: {
    encode: function (eventGroup) {
      return eventGroup;
    },
    decode: function (input) {
      return input;
    }
  },
  postProcess: {
    encode: function (output) {
      return output;
    },
    decode: function (eventGroup) {
      eventGroup = removeInvalidEvents(eventGroup);
      const postProcess = (lastDecodeOptions["Post Process"] || "yes") !== "no";
      if (!postProcess) {
        eventGroup.events = filterEvents(eventGroup.events.map(event => {
          event.text = event.text ? convertToHtml(event.text) : "";
          return event;
        }));
        return eventGroup;
      }
      eventGroup.events = tsFunc.cleanupTeletextEvents(eventGroup.events, {
        minDuration: 0.5,
        convertToHtml
      });
      eventGroup.events = filterEvents(eventGroup.events);
      return eventGroup;
    }
  }
};